<template lang="pug">
  li.accordion__item
    .accordion__trigger(
      :class="{'accordion__trigger_active': visible}"
      v-tap="open"
    )
      slot(name="accordion-trigger")
      .accordion__trigger-arrow(
        v-if="!hideArrow"
        :class="{'accordion__trigger-arrow_active': visible}"
      )

    transition(
      name="accordion"
      @enter="start"
      @after-enter="end"
      @before-leave="start"
      @after-leave="end"
    )
      .accordion__content(v-show="visible")
        .content-container
          slot(name="accordion-content")
</template>

<script>
export default {
  props: {
    hideArrow: {
      type: Boolean,
      default: false
    }
  },
  name: 'AccordionItem',
  inject: ['Accordion'],
  data: () => ({
    index: null
  }),
  computed: {
    visible () {
      return this.index === this.Accordion.active
    }
  },
  created () {
    this.index = this.Accordion.count++
  },
  methods: {
    open () {
      if (this.visible) {
        this.Accordion.active = null
      } else {
        this.Accordion.active = this.index
      }
    },
    start (el) {
      el.style.height = el.scrollHeight + 'px'
    },
    end (el) {
      el.style.height = ''
    }
  }
}
</script>
